import React from 'react'
import { Modal } from 'react-bootstrap';
import { Page, Text, View, Document, StyleSheet, PDFViewer } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: 'white',
    },
    section: {
        margin: 10,
        padding: 10,
        // flexGrow: 1
    },
    headingSection: {
        display: "flex",
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        margin: '10px 0',
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "nowrap", // Ensures that the row content doesn't wrapal

    },
  
    tableColHeader: {
        width: "50%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: "#e0e0e0",
        padding: 5,
    },
    tableColHeader1:{
        width: "6%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: "#e0e0e0",
        padding: 5,
    },
    tableColHeader3:{
        width: "10%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: "#e0e0e0",
        padding: 5,
    },
    tableColHeader4:{
        width: "10%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: "#e0e0e0",
        padding: 5,
    },
    tableColHeader5:{
        width: "18%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: "#e0e0e0",
        padding: 5,
    },
    tableColHeader6:{
        width: "15%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: "#e0e0e0",
        padding: 5,
    },
    tableCol: {
        width: "50%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5,
    },
    tableCol1:{
        width: "6%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5,
    },
    tableCol3:{
        width: "10%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5,
    },
    tableCol4:{
        width: "10%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5,
    },
    tableCol5:{
        width: "18%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5,
    },
    tableCol6:{
        width: "15%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5,
    },
    tableCell: {
        margin: "auto",
        fontSize: 9,
        textAlign: "left",
        // Ensures content is centered
    },
   
   
  
});

export default function ProductListPdf(props) {
    const { pdfModal, setPdfModal,  productData } = props;
    const handleClose = () => {
        { setPdfModal(false); }
    }


    const MyDocument = () => (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.section}>
                <View style={styles.headingSection}>
                        <Text>Product List</Text>
                       
                    </View>
                    <View style={styles.table}>
                        {/* Table Header */}
                        <View style={styles.tableRow}>
                            <View style={styles.tableColHeader1}>
                                <Text style={styles.tableCell}>SNO.</Text>
                            </View>
                            <View style={styles.tableColHeader}>
                                <Text style={styles.tableCell}>PRODUCT NAME</Text>
                            </View>
                            <View style={styles.tableColHeader3}>
                                <Text style={styles.tableCell}>UNIT</Text>
                            </View>
                            <View style={styles.tableColHeader4}>
                                <Text style={styles.tableCell}>SEC. UNIT</Text>
                            </View>
                            <View style={styles.tableColHeader5}>
                                <Text style={styles.tableCell}>GROUP</Text>
                            </View>
                            <View style={styles.tableColHeader6}>
                                <Text style={styles.tableCell}>RATE</Text>
                            </View>
                          
                        </View>
                        {/* Table Data */}
                        {productData?.map((item, index) => (
                            <View style={styles.tableRow} key={index}>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>{index + 1}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>{item.vitem_name}</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.tableCell}>{ item.mweight +  ' '  + item.vunit_short_name}</Text>
                                </View>
                                <View style={styles.tableCol4}>
                                    <Text style={styles.tableCell}>{item.vsecondary_unit}</Text>
                                </View>
                                <View style={styles.tableCol5}>
                                    <Text style={styles.tableCell}>{item.vgroup_short_name}</Text>
                                </View>
                                <View style={styles.tableCol6}>
                                    <Text style={styles.tableCell}>{item.mrate +  ' '  + item?.vunit_short_name}</Text>
                                </View>
                            </View>
                        ))}
                       
                    </View>
                </View>
            </Page>
        </Document>
    );

    return (
        <>
            <Modal show={pdfModal} onHide={handleClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>PDF GENRATE</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                      
                        <PDFViewer width="100%" height="600">
                            <MyDocument />
                        </PDFViewer>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
